import { actionTypes } from './constants';
import { createAsyncThunk } from '@reduxjs/toolkit';
import * as api from './api';

export const fetchAllUserSites = createAsyncThunk(
  actionTypes.FETCH_ALL_USER_SITES,
  async () => await api.fetchAllUserSitesApi(),
);
